import { z } from 'zod';

export const woocommerceIntegrationSchema = z.object({
  access_key: z.string().min(1, 'Informe a Consumer Key'),
  secret_key: z.string().min(1, 'Informe a Consumer Secret'),
  params: z.object({ store_url: z.string().min(1, 'Informe a URL da loja') }),
});

export const wbuyIntegrationSchema = z.object({
  access_key: z.string().min(1, 'Informe o usuário da API'),
  secret_key: z.string().min(1, 'Informe a chave da API'),
  params: z.object({ store_url: z.string().min(1, 'Informe a URL da loja') }),
});

export const shopifyStoreSchema = z.object({
  store_name: z.string().min(1, 'Informe o nome da loja').regex(/^[a-z0-9-]+$/i, 'Use apenas letras, números e hífen'),
});

export type WoocommerceIntegrationValues = z.infer<typeof woocommerceIntegrationSchema>;
export type WbuyIntegrationValues = z.infer<typeof wbuyIntegrationSchema>;
export type ShopifyStoreValues = z.infer<typeof shopifyStoreSchema>;

export interface CreateIntegrationPayload {
  type: string;
  code?: string;
  access_key?: string;
  secret_key?: string;
  params?: { store_url?: string; state?: string };
}
